import { Box, CardMedia } from "@mui/material";
import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";

const BackgroundVideo = () => {
  const videoRef = useRef(null);

  const tryPlay = () => {
    const video = videoRef.current;
    if (!video) return;

    video.play().catch(() => {
      // Autoplay blocked — expected on mobile
    });
  };

  useEffect(() => {
    // Try on mount
    tryPlay();

    // Try again on unlock / tab return
    document.addEventListener("visibilitychange", tryPlay);
    window.addEventListener("focus", tryPlay);

    // Resume on FIRST user interaction
    const resumeOnInteraction = () => {
      tryPlay();
      removeInteractionListeners();
    };

    const removeInteractionListeners = () => {
      window.removeEventListener("touchstart", resumeOnInteraction);
      window.removeEventListener("click", resumeOnInteraction);
      window.removeEventListener("scroll", resumeOnInteraction);
    };

    window.addEventListener("touchstart", resumeOnInteraction, {
      passive: true,
    });
    window.addEventListener("click", resumeOnInteraction);
    window.addEventListener("scroll", resumeOnInteraction, { passive: true });

    return () => {
      document.removeEventListener("visibilitychange", tryPlay);
      window.removeEventListener("focus", tryPlay);
      removeInteractionListeners();
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          overflow: "hidden",
          zIndex: -100,
          width: "100vw",
          height: "100vh",
        }}
      >
        <CardMedia
          preload="auto"
          component="video"
          ref={videoRef}
          image={require("../../assets/Pozadina.mp4")}
          loop
          muted
          playsInline
          autoPlay
          controls={false}
          sx={{
            minWidth: "100%",
            minHeight: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Box>
      <Outlet />
    </>
  );
};

export default BackgroundVideo;
